import React, { Fragment } from 'react';
import withData from 'util/hoc/with-data';
import withUser from 'util/hoc/with-user';
import Query from 'library/util/query';
import { resolve } from 'library/helpers/path-resolver';
import { object, bool } from 'prop-types';
import { displayDate } from 'library/util/display-date';
import * as StyledProfileCareer from './styled-profile-career';

const mapJobs = (job) => (
  <StyledProfileCareer.StyledJob>
    <StyledProfileCareer.StyledLabeledText> Job Title <p> {resolve(job, 'title', 'Not Provided')} </p> </StyledProfileCareer.StyledLabeledText>
    <StyledProfileCareer.StyledLabeledText> Company <p> {resolve(job, 'company', 'Not Provided')} </p> </StyledProfileCareer.StyledLabeledText>
    <StyledProfileCareer.StyledLabeledText> Time Period <p> {displayDate(resolve(job, 'date_range/start', ''), resolve(job, 'date_range/finish', ''))} </p> </StyledProfileCareer.StyledLabeledText>
    <StyledProfileCareer.StyledLabeledText> City  <p> {resolve(job, 'city', 'Not Provided')}  </p> </StyledProfileCareer.StyledLabeledText>
    <StyledProfileCareer.StyledLabeledText> State  <p> {resolve(job, 'state', 'Not Provided')}  </p> </StyledProfileCareer.StyledLabeledText>
    <StyledProfileCareer.StyledLabeledText width={'100%'}> Description  <p> {resolve(job, 'description', 'Not Provided')}  </p> </StyledProfileCareer.StyledLabeledText>
  </StyledProfileCareer.StyledJob>
);

const ProfileResume = (props) => {
  const {
    graph_data,
    graph_loading
  } = props;

  if (graph_loading) (
    <p> loading </p>
  );

  return (
    <Fragment>
      { resolve(graph_data, 'user/work_histories', []).length ?
        <StyledProfileCareer.StyledResumeSection>
          <h4> Resumé </h4>
          {resolve(graph_data, 'user/work_histories', []).map(mapJobs)}
        </StyledProfileCareer.StyledResumeSection>
        : null
      }
    </Fragment>
  );
};

ProfileResume.propTypes = {
  graph_data: object,
  graph_loading: bool
};

ProfileResume.query = (token, { user }) => (
  Query(`
    {
      user(id: ${user.id}) {
        work_histories {
         title
         company
         date_range {
           start
           finish
         }
         city
         state
         description
       }
     }
    }
  `)
);


export default withUser(withData(ProfileResume));
